module.exports = __webpack_public_path__ + "static/img/hero3.bad5a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero3.png
// module id = FKJz
// module chunks = 1